import React, { useEffect } from 'react';
import type { Updater } from 'use-immer';
import classNames from 'classnames';
import { type EffectSunlight, ImageType } from '@types';
import { Collapse } from '@components/Collapse';
import { MainPlayer } from '@stores/krpPlayerStores';
import Image from '@components/Image';
import {
  krpAddSunlight,
  krpAddSunlightHandler,
  krpRemoveEffect,
  krpRemoveSunlightHandler,
  krpUpdateSunlight,
} from '../actions/krpEffects';
import { SUNLIGHT_THUMB } from '../constants';
import { toggleSunlightTip } from '../SunlightTip';

interface Props {
  state: EffectSunlight;
  setState: Updater<EffectSunlight>;
}

const typeList: EffectSunlight['style'][] = [
  'blinkstyle4',
  'blinkstyle5',
  'blinkstyle6',
  'blinkstyle2',
  'blinkstyle1',
  'blinkstyle3',
  'blinkstyle7',
  'blinkstyle8',
  'blinkstyle9',
];

export function PanelEffectSunlight({ state, setState }: Props) {
  useEffect(() => {
    krpAddSunlight(state);
  }, []);

  useEffect(() => {
    krpAddSunlightHandler(state, (e) => {
      setState((draft) => {
        draft.atv = e.atv;
        draft.ath = e.ath;
      });
      krpUpdateSunlight({ id: state.id, atv: e.atv, ath: e.ath });
      toggleSunlightTip(false);
    });
    MainPlayer.get()?.lookTo({
      vlookat: state.atv,
      hlookat: state.ath,
    });
    return () => {
      krpRemoveEffect(state.id);
      krpRemoveSunlightHandler();
    };
  }, []);

  const handleTypeChange = (typeId: EffectSunlight['style']) => {
    setState((draft) => {
      draft.style = typeId;
    });
    krpUpdateSunlight({ id: state.id, style: typeId });
  };

  return (
    <Collapse title="效果选择">
      {typeList.map((typeId) => (
        <div
          key={typeId}
          className={classNames(
            'mb-25 cursor-pointer overflow-hidden rounded bg-black p-3',
            {
              'ring-2 ring-inset ring-orange': state.style === typeId,
            }
          )}
          onClick={() => {
            if (state.style !== typeId) {
              handleTypeChange(typeId);
            }
          }}
        >
          <Image
            type={ImageType.sysMedia}
            src={SUNLIGHT_THUMB[typeId]}
            className="max-h-full max-w-full"
          />
        </div>
      ))}
    </Collapse>
  );
}
